
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Playground from '@ecl/website-components/Playground';
import Spacing from '@ecl/website-components/Spacing/Spacing';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Use following classes to add extra spacing.`}</p>
    <p>{`Examples display outside spacing (margin) on the left and
inside spacing (padding) on the right.`}</p>
    <h2>{`All around spacing`}</h2>
    <Playground system="eu" selectedKind="utilities-spacing" selectedStory="default" mdxType="Playground">
  <Spacing type="a" token="2xs" mdxType="Spacing" />
  <Spacing type="a" token="xs" mdxType="Spacing" />
  <Spacing type="a" token="s" mdxType="Spacing" />
  <Spacing type="a" token="m" mdxType="Spacing" />
  <Spacing type="a" token="l" mdxType="Spacing" />
  <Spacing type="a" token="xl" mdxType="Spacing" />
  <Spacing type="a" token="2xl" mdxType="Spacing" />
  <Spacing type="a" token="3xl" mdxType="Spacing" />
  <Spacing type="a" token="4xl" mdxType="Spacing" />
    </Playground>
    <h2>{`Vertical spacing`}</h2>
    <Playground system="eu" selectedKind="utilities-spacing" selectedStory="default" mdxType="Playground">
  <Spacing type="v" token="2xs" mdxType="Spacing" />
  <Spacing type="v" token="xs" mdxType="Spacing" />
  <Spacing type="v" token="s" mdxType="Spacing" />
  <Spacing type="v" token="m" mdxType="Spacing" />
  <Spacing type="v" token="l" mdxType="Spacing" />
  <Spacing type="v" token="xl" mdxType="Spacing" />
  <Spacing type="v" token="2xl" mdxType="Spacing" />
  <Spacing type="v" token="3xl" mdxType="Spacing" />
  <Spacing type="v" token="4xl" mdxType="Spacing" />
    </Playground>
    <h3>{`Directional vertical spacing`}</h3>
    <ul>
      <li parentName="ul">{`Use classes `}<inlineCode parentName="li">{`ecl-u-mt-*`}</inlineCode>{` or `}<inlineCode parentName="li">{`ecl-u-pt-*`}</inlineCode>{` to add spacing only on top`}</li>
      <li parentName="ul">{`Use classes `}<inlineCode parentName="li">{`ecl-u-mb-*`}</inlineCode>{` or `}<inlineCode parentName="li">{`ecl-u-pb-*`}</inlineCode>{` to add spacing below.`}</li>
    </ul>
    <h2>{`Horizontal spacing`}</h2>
    <Playground system="eu" selectedKind="utilities-spacing" selectedStory="default" mdxType="Playground">
  <Spacing type="h" token="2xs" mdxType="Spacing" />
  <Spacing type="h" token="xs" mdxType="Spacing" />
  <Spacing type="h" token="s" mdxType="Spacing" />
  <Spacing type="h" token="m" mdxType="Spacing" />
  <Spacing type="h" token="l" mdxType="Spacing" />
  <Spacing type="h" token="xl" mdxType="Spacing" />
  <Spacing type="h" token="2xl" mdxType="Spacing" />
  <Spacing type="h" token="3xl" mdxType="Spacing" />
  <Spacing type="h" token="4xl" mdxType="Spacing" />
    </Playground>
    <h3>{`Directional horizontal spacing`}</h3>
    <ul>
      <li parentName="ul">{`Use classes `}<inlineCode parentName="li">{`ecl-u-ml-*`}</inlineCode>{` or `}<inlineCode parentName="li">{`ecl-u-pl-*`}</inlineCode>{` to add spacing only on the left`}</li>
      <li parentName="ul">{`Use classes `}<inlineCode parentName="li">{`ecl-u-mr-*`}</inlineCode>{` or `}<inlineCode parentName="li">{`ecl-u-pr-*`}</inlineCode>{` to add spacing on the right.`}</li>
    </ul>
    <h2>{`Other spacing`}</h2>
    <ul>
      <li parentName="ul">{`Use classes `}<inlineCode parentName="li">{`ecl-u-m*-auto`}</inlineCode>{` to set margin auto (horizontal, vertical or any direction)`}</li>
      <li parentName="ul">{`Use classes `}<inlineCode parentName="li">{`ecl-u-m*-none`}</inlineCode>{` or `}<inlineCode parentName="li">{`ecl-u-p*-none`}</inlineCode>{` to set margin or padding to zero.`}</li>
    </ul>
    <h2>{`Responsive spacing`}</h2>
    <p>{`Add the breakpoint before spacing size to display it only with corresponding screen size (works for all kind of spacing ahead).`}</p>
    <p>{`Examples:`}</p>
    <ul>
      <li parentName="ul">{`spacing `}<inlineCode parentName="li">{`l`}</inlineCode>{` on screen size >= breakpoint `}<inlineCode parentName="li">{`md`}</inlineCode><Spacing type="a-md" token="l" mdxType="Spacing" /></li>
      <li parentName="ul">{`horizontal spacing `}<inlineCode parentName="li">{`2xl`}</inlineCode>{` on screen size >= breakpoint `}<inlineCode parentName="li">{`lg`}</inlineCode><Spacing type="h-lg" token="2xl" mdxType="Spacing" /></li>
      <li parentName="ul">{`no left spacing on screen size >= breakpoint `}<inlineCode parentName="li">{`sm`}</inlineCode><Spacing type="l-sm" token="none" mdxType="Spacing" /></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;